'use strict';

angular.module('impactx.version', [
  'impactx.version.interpolate-filter',
  'impactx.version.version-directive'
])

.value('version', '0.1');
